import { HttpContextToken } from "@angular/common/http";

export const SUCCESS_TOAST = new HttpContextToken<string | null>(() => null);
// Optionnel : forcer le silence des erreurs déjà géré chez toi via SILENT_401 etc.
